import { Link } from '@mui/material'
import { prepareRoutes } from './utils/prepareRoutes'
import { routePaths } from './route-paths'

export const useProviderPortalManagementRoutes = () => {
	const routes = prepareRoutes(
		[
			{
				lazy: () =>
					import('pages/provider-portal-management').then((module) => ({
						Component: module.default,
					})),
				handle: {
					crumb: () => <Link href={routePaths.providerPortalManagement.path}>Provider Portal Management</Link>,
				},
				path: `${routePaths.providerPortalManagement.path}/*`,
			},
		],
		{},
	)

	return routes
}
